<template>
  <div
    v-if="section.children && section.children.length"
    data-scroll-lock-scrollable
    class="c-main-menu__dropdown"
  >
    <div class="c-main-menu__dropdown-bg">
      <div class="c-main-menu__dropdown-inner">
        <div
          v-for="(child, i) in section.children"
          :key="i"
          class="c-main-menu__dropdown-section"
        >
          <MenuItem
            class="c-main-menu__section-title font-normal"
            :item="child"
            :new-label="newLabel"
            @click="trackTitleClick(child.name)"
          />
          <ul
            v-if="child.children && child.children.length"
            class="c-main-menu__dropdown-list"
            :class="{
              'no-heading': !child.name
            }"
          >
            <li
              v-for="(subChild, j) in child.children"
              :key="j"
            >
              <MenuItem
                class="c-main-menu__dropdown-link"
                :item="subChild"
                :new-label="newLabel"
                @click="trackMenuClick(subChild.name)"
              />
            </li>
          </ul>
          <div
            v-if="child.seeAllLink"
            class="c-main-menu__see-all-link text-sm mt-6"
          >
            <a
              :href="child.seeAllLink.url"
              :target="child.seeAllLink.openInNewWindow ? '_blank' : '_self'"
            >
              <span class="action">
                <span>{{ child.seeAllLink.text }}</span>
                <span class="icon-arrow-right-new text-3xs ml-2" />
                <span class="icon-arrow-left text-3xs mr-2" />
              </span>
            </a>
          </div>
        </div>
        <div class="xl:hidden h-20 bg-white w-full curve-bottom--sub-element" />
        <MenuFeatured
          v-if="featuredNavigation"
          :model="featuredNavigation"
          class="text-blue-dark"
        />
      </div>
    </div>
  </div>
</template>

<script>
import tracking from '@/helpers/tracking'
import MenuItem from '@/components/MenuItem.vue'
import MenuFeatured from '@/components/MenuFeatured.vue'

export default {
  components: {
    MenuItem,
    MenuFeatured
  },
  props: {
    section: {
      type: Object,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    newLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    featuredNavigation() {
      if (!this.section.highlightedItems) {
        return null
      }
      const { header, items } = this.section.highlightedItems
      return items.length ? {
        header,
        items: items.map((item) => ({
          ...item,
          cardType: 'featuredMenuItem'
        }))
      } : null
    }
  },
  methods: {
    trackTitleClick(title) {
      tracking.mainMenuSectionTitleClick(title, this.section.name)
    },
    trackMenuClick(title) {
      tracking.mainMenuDropdownLinkClick(title, this.section.name)
    }
  }
}

</script>
